export const environment = {
    production: true,
    clientHost: 'https://staging.staftr.com/',
    apiUrl: 'https://staging-api.staftr.com/',
    adminAppUrl: 'https://admin-staging.staftr.com/admin',
    usSpecificTimezoneOnly: true,
    tokenRefreshBefore: -2,
    dateFormat: 'MM/dd/yyyy',
    title: "Staftr",
    favicon: 'assets/images/favicon_staftr.ico',
    firebaseConfig :{
        apiKey: "AIzaSyAr3j3zU9oZ7OYp6ITBBgnwKUoHrEVcm7M",
        authDomain: "mplace-dd342.firebaseapp.com",
        databaseURL: "https://mplace-stafter.firebaseio.com",
        projectId: "mplace-dd342",
        storageBucket: "",
        messagingSenderId: "136536185534",
        logging: true
    },
    unitTestConfig: {
        defaultPassword: "Tester@1234"
    },
    isPWCEnabled: false,
    mailToContact: 'info@mplace.io',
    privacyPolicyUrl: 'https://staftr.com/privacy-policy/',
    termsOfServiceUrl: 'https://staftr.com/terms-of-use/'
};
